import { GET_READY_READER_BY_SLUG } from "../../operations/queries/operations/queries/get-ready-reader-by-slug.js";
const getReadyReaderBySlug = async ({ client, slug, locale }) => {
  const queryResult = await client.query({
    query: GET_READY_READER_BY_SLUG,
    variables: { slug },
    context: { headers: { "Accept-Language": locale } }
  });
  return queryResult;
};
export {
  getReadyReaderBySlug
};
//# sourceMappingURL=getReadyReaderBySlug.js.map
